module.exports = __webpack_public_path__ + "static/media/Audio_similarity_search.206775ef.gif";